module.exports = __webpack_public_path__ + "static/media/carbon_sample_biophysical_table.a7e19508.csv";